import type { CapiProductPage } from 'types/capi/pdp';

import ChevronIcon from '~/assets/icons/Chevron';
import SizeSelectorGrid from '~/components/Pdp/WhereToBuy/SizeSelectorGrid';
import SizeInfo from '~/components/SizeInfo';
import usePageData from '~/hooks/usePageData';

import Title from './Title';

type Props = {
  forceShowSizeGrid?: boolean;
  selectedSize?: string;
  setSelectedSize: React.Dispatch<React.SetStateAction<string | undefined>>;
  setShowSizeGrid: React.Dispatch<React.SetStateAction<boolean>>;
  showSizeGrid: boolean;
  sizes: string[];
};

const SizeSelector = ({
  forceShowSizeGrid,
  selectedSize,
  setSelectedSize,
  setShowSizeGrid,
  showSizeGrid,
  sizes
}: Props) => {
  const product = usePageData<CapiProductPage>();

  const onGridToggleClick = () => {
    setShowSizeGrid(!showSizeGrid);
  };

  const onSizeSelect = (size: string) => {
    setSelectedSize(size);
    setShowSizeGrid(false);
  };

  const show = showSizeGrid || forceShowSizeGrid;

  return (
    <>
      <Title text="Select your size (UK)" />
      <div
        className="flex flex-col border-x border-b border-concrete"
        data-cy="size-selector"
      >
        {product.size_fit_guide && (
          <div className="border-b border-concrete p-4">
            <SizeInfo sizeFitGuide={product.size_fit_guide} />
          </div>
        )}

        {!forceShowSizeGrid && (
          <div className="w-full p-4">
            <button
              data-cy="size-selector-toggle"
              onClick={onGridToggleClick}
              className="flex w-full items-center justify-between gap-4"
            >
              <span>{selectedSize ? `UK ${selectedSize}` : 'All sizes'}</span>
              <span className={show ? 'rotate-180' : ''}>
                <ChevronIcon height="6" stroke="black" width="10" />
              </span>
            </button>
          </div>
        )}

        {show && (
          <>
            <div className="w-full p-4">
              <SizeSelectorGrid
                onSizeSelect={onSizeSelect}
                selectedSize={selectedSize}
                sizes={sizes}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default SizeSelector;
